<template>
    <div>
        {{ length }} <span v-if="showMax"> / {{ max }}</span>
    </div>
</template>

<script>
export default {
    name: 'CharCounter',
    props: {
        value: {
            required: true,
        },
        max: {
            required: false,
            type: Number,
        },
        showMax: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    computed: {
        length: function () {
            if (typeof this.value === 'string') {
                return this.value.length;
            }

            return 0;
        },
    },
};
</script>
